export default {
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    view: 'Voir',
    add: 'Ajouter',
    search: 'Rechercher',
    filter: 'Filtrer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès'
  },
  nav: {
    dashboard: 'Tableau de bord',
    members: 'Membres',
    membershipPlans: 'Plans d\'adhésion',
    payments: 'Paiements',
    attendance: 'Présence',
    reports: 'Rapports',
    gymProfile: 'Profil de gym',
    settings: 'Paramètres',
    logout: 'Se déconnecter'
  },
  gymProfile: {
    title: 'Profil de gym',
    languageSettings: 'Paramètres de langue',
    currentLanguage: 'Langue actuelle',
    selectLanguage: 'Sélectionner une nouvelle langue',
    chooseLanguage: 'Choisir la langue...'
  },
  messages: {
    languageUpdated: 'Langue mise à jour avec succès!'
  }
};